import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { State } from './state';

export const getState: MemoizedSelector<object, State> = createFeatureSelector<State>('towAttempt');

export const getTotal: MemoizedSelector<object, number> = createSelector(getState, (state: State) => state.total);

export const getLoading: MemoizedSelector<object, boolean> = createSelector(getState, (state: State) => state.loading);

export const getError: MemoizedSelector<object, string> = createSelector(getState, (state: State) => state.error);
